import { Check, ChevronsUpDown } from 'lucide-react'
import { useEffect, useState } from 'react'
import { cn } from '../../../../lib/utils'
import { Button } from '../../../components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../../components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover'
import { useToast } from '../../../hooks'
import { loadPlans } from './actions/load-plans'

interface PlansTabProps {
  setPlanSelected: (data: string) => void
  defaultPlan?: string
  valueWatcher?: any
}

export function PlansTab({ setPlanSelected, defaultPlan, valueWatcher }: PlansTabProps) {
  const { showToast } = useToast()
  const { data: plans } = loadPlans()
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(() => defaultPlan || '')

  useEffect(() => {
    if (plans) {
      const data = plans?.find((item) => item.id == value)
      if (data) {
        setPlanSelected(data)
        setValue(data.value)
      }
    }
  }, [plans])

  const addInCart = () => {
    const data = plans?.find((item) => item.id == value)
    if (data) {
      setPlanSelected(data)
      showToast('Plano adicionado ao carrinho', 'success')
    }
  }

  useEffect(() => {
    if (valueWatcher) {
      setValue('')
    }
  }, [valueWatcher])

  return (
    <div className="w-full">
      <label className="font-semibold">Planos</label>
      <div className="flex gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between">
              {value ? plans?.find((framework) => framework.value === value)?.label : 'Selecione...'}
              <ChevronsUpDown className="opacity-50" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="min-w-full p-0">
            <Command>
              <CommandInput placeholder="Pesquisar..." className="h-9" />
              <CommandList>
                <CommandEmpty>Não encontrado.</CommandEmpty>
                <CommandGroup>
                  {plans &&
                    plans.map((item) => (
                      <CommandItem
                        key={item.value}
                        value={item.value}
                        keywords={[item.label]}
                        onSelect={(currentValue) => {
                          setValue(currentValue === value ? '' : currentValue)
                          setOpen(false)
                        }}
                      >
                        {item.label}
                        <Check className={cn('ml-auto', value === item.value ? 'opacity-100' : 'opacity-0')} />
                      </CommandItem>
                    ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        <Button className="bg-acelerafit-green-400 text-muted hover:bg-cashfit-green-200" onClick={addInCart}>
          Adicionar ao carrinho
        </Button>
      </div>
    </div>
  )
}
